/* eslint-disable no-useless-catch */
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/budget-items';

export const BudgetItemApi = {
  findMasterData: async () => {
    const url = `${pathname}/master-data`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },
};
